import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

import { AnchorNavigationComponent } from './anchor-navigation.component';
import { TranslateModule } from "@ngx-translate/core";



@NgModule({
  declarations: [
    AnchorNavigationComponent
  ],
  exports: [
    AnchorNavigationComponent
  ],
    imports: [
        CommonModule,
        RouterLink,
        TranslateModule
    ]
})
export class AnchorNavigationModule { }
